interface ISlideMenuBarProps {
    cssName?: string;
}

export function SlideMenuBar(props: ISlideMenuBarProps): JSX.Element {
    return (
        <div className={`slide-menu-icon blue ${props.cssName ?? ""}`}>
            <span />
            <span />
            <span />
        </div>
    );
}
